package pwgs.ui.scenes.playerslistscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.dom.div
import visage.ds.components.*
import visage.ds.components.page.Page
import visage.ds.utils.ETextAlign

class MPlayersListScene(props: PlayersListSceneProps) : AScene<PlayersListSceneProps, PlayersListSceneModel, PlayersListSceneState, PlayersListControllerFe>(props) {

    override fun createController() : PlayersListControllerFe {
        return PlayersListControllerFe(props, this)
    }

    override fun initState() : PlayersListSceneState {
        return PlayersListSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MPlayersListScene.model
        val c = this@MPlayersListScene.controller
        Page {
            head("Players")

            body {
                Card {
                    isLoading = m.isLoading
                    header("Players") {

                    }

                    body {
                        div {
                            style.apply {
                                width = "100%"
                                padding = "16px"
                            }
                            div {
                                style.apply {
                                    width = "400px"
                                    display = "inline-block"
                                }
                                TextField("Search (username)", m.searchFieldModel)
                            }
                            div {
                                style.apply {
                                    width = "16px"
                                    display = "inline-block"
                                }
                            }
                            div {
                                style.apply {
                                    width = "200px"
                                    display = "inline-block"
                                }
                                Button("Search") {
                                    onClick = c::onSearchButtonClicked
                                }
                            }

                        }


                        if (m.searchResults.isEmpty()) {
                            Text("No results found.", ETextStyles.Normal, false) {
                                textAlign = ETextAlign.CENTER
                            }
                            div {
                                style.height = "16px"
                            }
                        } else {
                            Table {
                                columns {
                                    fixedColumn("ID")
                                    fixedColumn("Username")
                                    fixedColumn("Visible Name")
                                }
                                body {
                                    m.searchResults.forEach { player ->
                                        row {
                                            cell(player.id)
                                            cell(player.userName)
                                            cell(player.visibleName)
                                            onClick = {c.onPlayerListItemClicked(player.id)}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class PlayersListSceneState {

}

fun Components.PlayersListScene(props: PlayersListSceneProps) = this.registerComponent(MPlayersListScene(props), {})
